import script from "./ParamsFormGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./ParamsFormGroup.vue?vue&type=script&lang=ts&setup=true"

import "./ParamsFormGroup.vue?vue&type=style&index=0&id=6f0b1d1d&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f0b1d1d"]])

export default __exports__